import { useReducer, useEffect } from 'react';
import { AppDispatcher } from 'services/PubSub/'

const Reducer = (reducer, initialState) => {
    const [state, dispatch] = useReducer(reducer, initialState || null);

    useEffect(() => {
        const token = AppDispatcher.register((payload) => {
            dispatch(payload);
        });

        return () => {
            AppDispatcher.unregister(token);
        };
    }, []);

    return state;
}

export {
    Reducer
};
